export default __webpack_public_path__ + "static/kv-banner-lt-kr-f9a86da73e5e2fc0d4bd5f7d7b9e59fa.png";